import { DateBetween, isStepActive } from "../../utils/date";
import NuDate from "../Utils/NuDate";

const ORDER_FLOW_STEPS = [
  { order: 1, label: "PR Created", statuses: ["PR Created"] },
  { order: 2, label: "RFQ Floated", statuses: ["RFQ Floated"] },
  { order: 3, label: "Supplier Price Received" },

  { order: 4, label: "Customer Quote Approved" },
  { order: 5, label: "Quote Submitted to Customer" },
  { order: 6, label: "PO Received / Lost Order" },
  { order: 7, label: "Sales Order Released" },

  { order: 8, label: "PO to Supplier Approved" },
  { order: 9, label: "PO placed with Supplier" },
  { order: 10, label: "Order Shipped" },
  { order: 11, label: "Order Under Customer Clearance" },
  { order: 12, label: "Order Received at Warehouse" },
  { order: 13, label: "Delivered to Customer" },
];

export const OrderFlow = ({ yprno, value, closedate }) => {
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
      <div className="animate-scale-in min-w-[85%] max-w-[95%] min-h-[55vh] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
        <h2 className="text-center font-semibold mb-4 text-sm 2xl:text-base">
          Order Flow{" "}
          <span className=" text-gray-700 text-xs 2xl:text-sm">({yprno})</span>
        </h2>
        <div className=" w-full grid grid-cols-12 gap-0">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div className=" border-b-[1.5px] border-x-0 h-28  relative"></div>
          <div className=" border-[1.5px] border-x-0 h-28 relative">
            <div className="absolute -top-2 2xl:-top-2.5 text-slate-400 left-0 w-4 h-4 2xl:w-5 2xl:h-5 bg-green-500 rounded-full flex justify-center items-center">
              {(value[0]?.order === 1 && value[0]?.status === "PR Created") !=
                true && (
                  <div className=" w-4 h-4 2xl:w-5 2xl:h-5 bg-slate-400 rounded-full "></div>
                )}
            </div>
            <div
              className={`${(value[0]?.order === 1 && value[0]?.status === "PR Created") ===
                true
                ? " text-black"
                : " text-slate-500"
                } absolute -left-6 top-3 w-[170px] 2xl:w-[200px]`}
            >
              <p className=" text-[10px] 2xl:text-xs">YPR Created</p>
              <p className="text-[10px]  2xl:text-xs">
                {value[0]?.order === 1 && value[0]?.status === "PR Created" && (
                  <NuDate value={value[0]?.date} format="DD-MMM-YYYY" />
                )}
              </p>
            </div>
          </div>

          <div className=" border-[1.5px] border-x-0 h-28 relative"></div>

          <div className=" border-[1.5px] border-x-0 h-28 relative">
            <div>
              <span className=" text-gray-400 text-3xl 2xl:text-4xl absolute -top-5 2xl:-top-[22px] -left-20 2xl:-left-24">
                &#129170;
              </span>
              {/* {(value[1]?.order === 2 && value[1]?.status === "RFQ Floated") &&
              <p className="absolute pt-0.5 2xl:pt-1 text-slate-700 -top-0 2xl:-top-[2px] -left-24 2xl:-left-28 text-[10px]  2xl:text-xs">
              {DateBetween(value[0]?.date,value[1]?.date)} {DateBetween(value[0]?.date,value[1]?.date) > 1 ? "Days":"Day"}
    </p>} */}
            </div>
            <div className="absolute -top-2 2xl:-top-2.5 text-slate-400 left-0 w-4 h-4 2xl:w-5 2xl:h-5 bg-green-500 rounded-full flex justify-center items-center">
              {(value[1]?.order === 2 && value[1]?.status === "RFQ Floated") !=
                true && (
                  <div className=" w-4 h-4 2xl:w-5 2xl:h-5 bg-slate-400 rounded-full "></div>
                )}
            </div>
            <div
              className={`${(value[1]?.order === 2 &&
                value[1]?.status === "RFQ Floated") === true
                ? " text-black"
                : " text-slate-500"
                } absolute -left-6 top-3 w-[170px] 2xl:w-[200px]`}
            >
              <p className=" text-[10px]  2xl:text-xs absolute left-1">
                RFQ Floated
              </p>
              <p className="text-[10px]  2xl:text-xs absolute left-0.5 top-4">
                {value[1]?.order === 2 &&
                  value[1]?.status === "RFQ Floated" && (
                    <NuDate value={value[1]?.date} format="DD-MMM-YYYY" />
                  )}
              </p>
              {value[1]?.order === 2 && value[1]?.status === "RFQ Floated" && (
                <p className=" text-[10px]   2xl:text-xs absolute left-5 top-8  text-center items-center">
                  {DateBetween(value[0]?.date, value[1]?.date)}{" "}
                  {DateBetween(value[0]?.date, value[1]?.date) > 1
                    ? "Days"
                    : "Day"}
                </p>
              )}
            </div>
          </div>
          <div className=" border-[1.5px] border-x-0 h-28 relative"></div>

          <div className=" border-[1.5px] border-x-0 h-28 relative">
            <div>
              <span className=" text-gray-400 text-3xl 2xl:text-4xl absolute -top-5 2xl:-top-[22px] -left-20 2xl:-left-24">
                &#129170;
              </span>
            </div>{" "}
            <div className="absolute -top-2 2xl:-top-2.5 text-slate-400 left-0 w-4 h-4 2xl:w-5 2xl:h-5 bg-green-500 rounded-full flex justify-center items-center">
              {(value[2]?.order === 3 &&
                value[2]?.status === "Supplier Price Received") != true && (
                  <div className=" w-4 h-4 2xl:w-5 2xl:h-5 bg-slate-400 rounded-full "></div>
                )}
            </div>
            <div
              className={`${(value[2]?.order === 3 &&
                value[2]?.status === "Supplier Price Received") === true
                ? " text-black"
                : " text-slate-500"
                } absolute -left-12 top-3 w-[170px] 2xl:w-[200px]`}
            >
              <p className=" text-[10px]  2xl:text-xs absolute -left-0 2xl:-left-2">
                Supplier Price Received
              </p>
              <p className="text-[10px]  2xl:text-xs absolute left-8 2xl:left-6  top-4 text-center items-center">
                {value[2]?.order === 3 &&
                  value[2]?.status === "Supplier Price Received" && (
                    <NuDate value={value[2]?.date} format="DD-MMM-YYYY" />
                  )}
              </p>
              {value[2]?.order === 3 &&
                value[2]?.status === "Supplier Price Received" && (
                  <p className=" text-[10px]  2xl:text-xs absolute left-12 2xl:left-11 top-8  text-center items-centers">
                    {DateBetween(value[0]?.date, value[2]?.date)}{" "}
                    {DateBetween(value[0]?.date, value[2]?.date) > 1
                      ? "Days"
                      : "Day"}
                  </p>
                )}
            </div>
          </div>

          <div className=" border-[1.5px] border-x-0 h-28 relative"></div>
          <div className=" border-[1.5px] border-x-0 h-28 relative">
            <div>
              <span className=" text-gray-400 text-3xl 2xl:text-4xl absolute -top-5 2xl:-top-[22px] -left-20 2xl:-left-24">
                &#129170;
              </span>
            </div>{" "}
            <div className="absolute -top-2 2xl:-top-2.5 text-slate-400 left-0 w-4 h-4 2xl:w-5 2xl:h-5 bg-green-500 rounded-full flex justify-center items-center">
              {(value[3]?.order === 4 &&
                value[3]?.status === "Customer Quote Approved") != true && (
                  <div className=" w-4 h-4 2xl:w-5 2xl:h-5 bg-slate-400 rounded-full "></div>
                )}
            </div>
            <div
              className={`${(value[3]?.order === 4 &&
                value[3]?.status === "Customer Quote Approved") === true
                ? " text-black"
                : " text-slate-500"
                } absolute -left-14 top-3 w-[170px] 2xl:w-[200px]`}
            >
              <p className=" text-[10px]  2xl:text-xs  absolute left-0.5 2xl:-left-2">
                Customer Quote Approved
              </p>
              <p className="text-[10px]  2xl:text-xs absolute left-10 2xl:left-9 top-4">
                {value[3]?.order === 4 &&
                  value[3]?.status === "Customer Quote Approved" && (
                    <NuDate value={value[3]?.date} format="DD-MMM-YYYY" />
                  )}
              </p>
              {value[3]?.order === 4 &&
                value[3]?.status === "Customer Quote Approved" && (
                  <p className=" text-[10px]  2xl:text-xs absolute left-14 2xl:left-14 top-8  text-center items-center">
                    {DateBetween(value[0]?.date, value[3]?.date)}{" "}
                    {DateBetween(value[0]?.date, value[3]?.date) > 1
                      ? "Days"
                      : "Day"}
                  </p>
                )}
            </div>
          </div>

          <div className=" border-[1.5px] border-x-0 h-28 relative"></div>

          <div className=" border-[1.5px] border-x-0 h-28 relative">
            <div>
              <span className=" text-gray-400 text-3xl 2xl:text-4xl absolute -top-5 2xl:-top-[22px] -left-20 2xl:-left-24">
                &#129170;
              </span>
            </div>
            <div className="absolute -top-2 2xl:-top-2.5 text-slate-400 left-0 w-4 h-4 2xl:w-5 2xl:h-5 bg-green-500 rounded-full flex justify-center items-center">
              {(value[4]?.order === 5 &&
                value[4]?.status === "Quote Submitted to Customer") != true && (
                  <div className=" w-4 h-4 2xl:w-5 2xl:h-5 bg-slate-400 rounded-full "></div>
                )}
            </div>
            <div
              className={`${(value[4]?.order === 5 &&
                value[4]?.status === "Quote Submitted to Customer") === true
                ? " text-black"
                : " text-slate-500"
                } absolute -left-14 top-3 w-[170px] 2xl:w-[200px]`}
            >
              <p className=" text-[10px] 2xl:text-xs absolute -left-1 2xl:-left-2">
                Quote Submitted to Customer
              </p>
              <p className="text-[10px]  2xl:text-xs absolute left-10 2xl:left-9 top-4">
                {value[4]?.order === 5 &&
                  value[4]?.status === "Quote Submitted to Customer" && (
                    <NuDate value={value[4]?.date} format="DD-MMM-YYYY" />
                  )}
              </p>
              {value[4]?.order === 5 &&
                value[4]?.status === "Quote Submitted to Customer" && (
                  <p className="text-[10px]  2xl:text-xs absolute left-14 2xl:left-14 top-8">
                    {DateBetween(value[0]?.date, value[4]?.date)}{" "}
                    {DateBetween(value[0]?.date, value[4]?.date) > 1
                      ? "Days"
                      : "Day"}
                  </p>
                )}
            </div>
          </div>
          <div className=" border-[1.5px] border-l-0 h-28 rounded-e-full"></div>
          <div className=" border-[1.5px] border-r-0 h-28 rounded-s-full"></div>
          <div className=" border-b-[1.5px] h-28 relative">
            <div className="absolute -top-2 2xl:-top-2.5 text-slate-400 left-0 w-4 h-4 2xl:w-5 2xl:h-5 bg-green-500 rounded-full flex justify-center items-center">
              <div>
                <span className=" text-gray-400 text-3xl 2xl:text-4xl absolute -top-3 2xl:-top-3 -right-20 2xl:-right-24">
                  &#129168;
                </span>
                {/* {(value[9]?.order === 10 && value[9]?.status === "Order Shipped")  &&
                  <p className="absolute pt-4 2xl:pt-3 text-slate-700  -top-1 2xl:-top-0 -right-24 2xl:-right-28 text-[10px]  2xl:text-xs">
       {DateBetween(value[0]?.date,value[9]?.date)} {DateBetween(value[0]?.date,value[9]?.date) > 1 ? "Days":"Day"}
    </p>} */}
              </div>
              {(value[9]?.order === 10 &&
                value[9]?.status === "Order Shipped") != true && (
                  <div className=" w-4 h-4 2xl:w-5 2xl:h-5 bg-slate-400 rounded-full "></div>
                )}
            </div>
            <div
              className={`${(value[9]?.order === 10 &&
                value[9]?.status === "Order Shipped") === true
                ? " text-black"
                : " text-slate-500"
                } absolute -left-5 top-3 w-[170px] 2xl:w-[200px]`}
            >
              <p className=" text-[10px] 2xl:text-xs absolute -left-1 2xl:-left-2">
                Order Shipped
              </p>
              <p className="text-[10px]  2xl:text-xs absolute -left-0.5 2xl:left-0 top-4">
                {value[9]?.order === 10 &&
                  value[9]?.status === "Order Shipped" && (
                    <NuDate value={value[9]?.date} format="DD-MMM-YYYY" />
                  )}
              </p>
              {value[9]?.order === 10 &&
                value[9]?.status === "Order Shipped" && (
                  <p className=" text-[10px]  2xl:text-xs absolute left-3 2xl:left-4 top-8">
                    {DateBetween(value[0]?.date, value[9]?.date)}{" "}
                    {DateBetween(value[0]?.date, value[9]?.date) > 1
                      ? "Days"
                      : "Day"}
                  </p>
                )}
            </div>
          </div>
          <div className=" border-b-[1.5px] h-28"></div>
          <div className=" border-b-[1.5px] h-28 relative">
            <div className="absolute -top-2 2xl:-top-2.5 text-slate-400 left-0 w-4 h-4 2xl:w-5 2xl:h-5 bg-green-500 rounded-full flex justify-center items-center">
              <div>
                <span className=" text-gray-400 text-3xl 2xl:text-4xl absolute -top-3 2xl:-top-3 -right-20 2xl:-right-24">
                  &#129168;
                </span>
              </div>{" "}
              {(value[8]?.order === 9 &&
                value[8]?.status === "PO placed with Supplier") != true && (
                  <div className=" w-4 h-4 2xl:w-5 2xl:h-5 bg-slate-400 rounded-full "></div>
                )}
            </div>
            <div
              className={`${(value[8]?.order === 9 &&
                value[8]?.status === "PO placed with Supplier") === true
                ? " text-black"
                : " text-slate-500"
                } absolute -left-11 top-3 w-[170px] 2xl:w-[200px]`}
            >
              <p className=" text-[10px] 2xl:text-xs absolute -left-1 2xl:-left-2 ">
                PO placed with Supplier
              </p>
              <p className="text-[10px]  2xl:text-xs absolute left-6 2xl:left-6 top-4">
                {value[8]?.order === 9 &&
                  value[8]?.status === "PO placed with Supplier" && (
                    <NuDate value={value[8]?.date} format="DD-MMM-YYYY" />
                  )}
              </p>
              {value[8]?.order === 9 &&
                value[8]?.status === "PO placed with Supplier" && (
                  <p className=" text-[10px]  2xl:text-xs absolute left-9 2xl:left-10 top-8">
                    {DateBetween(value[0]?.date, value[8]?.date)}{" "}
                    {DateBetween(value[0]?.date, value[8]?.date) > 1
                      ? "Days"
                      : "Day"}
                  </p>
                )}
            </div>
          </div>
          <div className=" border-b-[1.5px] h-28"></div>
          <div className=" border-b-[1.5px] h-28 relative">
            <div className="absolute -top-2 2xl:-top-2.5 text-slate-400 left-0 w-4 h-4 2xl:w-5 2xl:h-5 bg-green-500 rounded-full flex justify-center items-center">
              <div>
                <span className=" text-gray-400 text-3xl 2xl:text-4xl absolute -top-3 2xl:-top-3 -right-20 2xl:-right-24">
                  &#129168;
                </span>
              </div>{" "}
              {(value[7]?.order === 8 &&
                value[7]?.status === "PO to Supplier Approved") != true && (
                  <div className=" w-4 h-4 2xl:w-5 2xl:h-5 bg-slate-400 rounded-full "></div>
                )}
            </div>
            <div
              className={`${(value[7]?.order === 8 &&
                value[7]?.status === "PO to Supplier Approved") === true
                ? " text-black"
                : " text-slate-500"
                } absolute -left-11 top-3 w-[170px] 2xl:w-[200px]`}
            >
              <p className=" text-[10px] 2xl:text-xs absolute -left-1 2xl:-left-2 ">
                Po to Supplier Approved
              </p>
              <p className="text-[10px]  2xl:text-xs absolute left-6 2xl:left-6 top-4">
                {value[7]?.order === 8 &&
                  value[7]?.status === "PO to Supplier Approved" && (
                    <NuDate value={value[7]?.date} format="DD-MMM-YYYY" />
                  )}
              </p>
              {value[7]?.order === 8 &&
                value[7]?.status === "PO to Supplier Approved" && (
                  <p className=" text-[10px]  2xl:text-xs absolute left-10 2xl:left-10 top-8">
                    {DateBetween(value[0]?.date, value[7]?.date)}{" "}
                    {DateBetween(value[0]?.date, value[7]?.date) > 1
                      ? "Days"
                      : "Day"}
                  </p>
                )}
            </div>
          </div>
          <div></div>
          <div className=" h-28 relative">
            <div className="absolute -top-2 2xl:-top-2.5 text-slate-400 left-0 w-4 h-4 2xl:w-5 2xl:h-5 bg-green-500 rounded-full flex justify-center items-center">
              <div>
                <span className=" text-gray-400 text-3xl 2xl:text-4xl absolute -top-3 2xl:-top-3 -right-20 2xl:-right-24">
                  &#129168;
                </span>
              </div>{" "}
              {(value[6]?.order === 7 &&
                value[6]?.status === "Sales Order Released") != true && (
                  <div className=" w-4 h-4 2xl:w-5 2xl:h-5 bg-slate-400 rounded-full "></div>
                )}
            </div>
            <div
              className={`${(value[6]?.order === 7 &&
                value[6]?.status === "Sales Order Released") === true
                ? " text-black"
                : " text-slate-500"
                } absolute -left-10 top-3 w-[170px] 2xl:w-[200px]`}
            >
              <p className=" text-[10px] 2xl:text-xs absolute -left-1 2xl:-left-2 ">
                Sales Order Released
              </p>
              <p className="text-[10px]  2xl:text-xs absolute left-5 2xl:left-5 top-4">
                {" "}
                {value[6]?.order === 7 &&
                  value[6]?.status === "Sales Order Released" && (
                    <NuDate value={value[6]?.date} format="DD-MMM-YYYY" />
                  )}
              </p>
              {value[6]?.order === 7 &&
                value[6]?.status === "Sales Order Released" && (
                  <p className=" text-[10px]  2xl:text-xs absolute left-9 2xl:left-10 top-8">
                    {DateBetween(value[0]?.date, value[6]?.date)}{" "}
                    {DateBetween(value[0]?.date, value[6]?.date) > 1
                      ? "Days"
                      : "Day"}
                  </p>
                )}
            </div>
          </div>
          <div></div>
          <div className=" h-28 relative">
            <div className="absolute -top-2 2xl:-top-2.5 text-slate-400 left-0 w-4 h-4 2xl:w-5 2xl:h-5 bg-green-500 rounded-full flex justify-center items-center">
              <div>
                <span className=" text-gray-400 text-3xl 2xl:text-4xl absolute -top-3 2xl:-top-3 -right-20 2xl:-right-24">
                  &#129168;
                </span>
              </div>{" "}
              {(value[5]?.order === 6 &&
                (value[5]?.status === "PO Received from customer" ||
                  value[5]?.status === "Lost the Order")) != true && (
                  <div className=" w-4 h-4 2xl:w-5 2xl:h-5 bg-slate-400 rounded-full "></div>
                )}
            </div>
            <div
              className={`${(value[5]?.order === 6 &&
                (value[5]?.status === "PO Received from customer" ||
                  value[5]?.status === "Lost the Order")) === true
                ? " text-black"
                : " text-slate-500"
                } absolute -left-16 top-3 w-[170px] 2xl:w-[200px]`}
            >
              <p className=" text-[10px] 2xl:text-xs absolute -left-1 2xl:-left-3 ">
                {value[5]?.status === "PO Received from customer"
                  ? "PO Received from customer"
                  : value[5]?.status === "Lost the Order"
                    ? ""
                    : "PO Received from customer / Lost the Order"}
              </p>
              <p className="text-[10px]  2xl:text-xs absolute left-11 2xl:left-11 top-8">
                {value[5]?.order === 6 &&
                  (value[5]?.status === "PO Received from customer" ||
                    value[5]?.status === "Lost the Order") && (
                    <NuDate value={value[5]?.date} format="DD-MMM-YYYY" />
                  )}
              </p>
              {value[5]?.order === 6 &&
                (value[5]?.status === "PO Received from customer" ||
                  value[5]?.status === "Lost the Order") && (
                  <p className=" text-[10px]  2xl:text-xs absolute left-14 2xl:left-16 top-12">
                    {DateBetween(value[0]?.date, value[5]?.date)}{" "}
                    {DateBetween(value[0]?.date, value[5]?.date) > 1
                      ? "Days"
                      : "Day"}
                  </p>
                )}
            </div>
          </div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div className="relative">
            <div>
              <span className=" text-gray-400 text-3xl 2xl:text-4xl absolute -top-5 2xl:-top-[22px] -left-20 2xl:-left-24">
                &#129170;
              </span>
              {/* {(value[10]?.order === 11 && value[10]?.status === "Order Under Customers clearance") &&
              <p className="absolute pt-0.5 2xl:pt-1 text-slate-700 -top-0 2xl:-top-[2px] -left-24 2xl:-left-28 text-[10px]  2xl:text-xs">
       {DateBetween(value[0]?.date,value[10]?.date)} {DateBetween(value[0]?.date,value[10]?.date) > 1 ? "Days":"Day"}
    </p>} */}
            </div>{" "}
            <div className="absolute -top-2 2xl:-top-2.5 text-slate-400 left-0 w-4 h-4 2xl:w-5 2xl:h-5 bg-green-500 rounded-full flex justify-center items-center">
              {(value[10]?.order === 11 &&
                value[10]?.status === "Order Under Customers clearance") !=
                true && (
                  <div className=" w-4 h-4 2xl:w-5 2xl:h-5 bg-slate-400 rounded-full "></div>
                )}
            </div>
            <div
              className={`${(value[10]?.order === 11 &&
                value[10]?.status === "Order Under Customers clearance") ===
                true
                ? " text-black"
                : " text-slate-500"
                } absolute -left-12 top-3 w-[170px] 2xl:w-[200px]`}
            >
              <p className=" text-[10px]  2xl:text-xs absolute left-1 2xl:-left-0.5 ">
                Order Under Customers{" "}
              </p>
              <p className=" text-[10px]  2xl:text-xs absolute left-8 2xl:left-6 top-3 2xl:top-4 ">
                {" "}
                Clearance
              </p>

              <p className="text-[10px]  2xl:text-xs absolute left-6 2xl:left-5 top-7 2xl:top-8">
                {value[10]?.order === 11 &&
                  value[10]?.status === "Order Under Customers clearance" && (
                    <NuDate value={value[10]?.date} format="DD-MMM-YYYY" />
                  )}
              </p>
              {value[10]?.order === 11 &&
                value[10]?.status === "Order Under Customers clearance" && (
                  <p className=" text-[10px]  2xl:text-xs absolute left-10 2xl:left-10 top-10 2xl:top-12">
                    {DateBetween(value[0]?.date, value[10]?.date)}{" "}
                    {DateBetween(value[0]?.date, value[10]?.date) > 1
                      ? "Days"
                      : "Day"}
                  </p>
                )}
            </div>
          </div>
          <div></div>
          <div className="relative">
            <div>
              <span className=" text-gray-400 text-3xl 2xl:text-4xl absolute -top-5 2xl:-top-[22px] -left-20 2xl:-left-24">
                &#129170;
              </span>
            </div>{" "}
            <div className="absolute -top-2 2xl:-top-2.5 text-slate-400 left-0 w-4 h-4 2xl:w-5 2xl:h-5 bg-green-500 rounded-full flex justify-center items-center">
              {(value[11]?.order === 12 &&
                value[11]?.status === "Order Received at Warehouse") !=
                true && (
                  <div className=" w-4 h-4 2xl:w-5 2xl:h-5 bg-slate-400 rounded-full "></div>
                )}
            </div>
            <div
              className={`${(value[11]?.order === 12 &&
                value[11]?.status === "Order Received at Warehouse") === true
                ? " text-black"
                : " text-slate-500"
                } absolute -left-14 top-3 w-[170px] 2xl:w-[200px]`}
            >
              <p className=" text-[10px] 2xl:text-xs absolute -left-4  2xl:-left-5 ">
                Order Received at Warehouse
              </p>
              <p className="text-[10px]  2xl:text-xs absolute left-9 2xl:left-9 top-4">
                {value[11]?.order === 12 &&
                  value[11]?.status === "Order Received at Warehouse" && (
                    <NuDate value={value[11]?.date} format="DD-MMM-YYYY" />
                  )}
              </p>
              {value[11]?.order === 12 &&
                value[11]?.status === "Order Received at Warehouse" && (
                  <p className=" text-[10px]  2xl:text-xs absolute left-12 2xl:left-14 top-8">
                    {DateBetween(value[0]?.date, value[11]?.date)}{" "}
                    {DateBetween(value[0]?.date, value[11]?.date) > 1
                      ? "Days"
                      : "Day"}
                  </p>
                )}
            </div>
          </div>
          <div></div>
          <div className="relative">
            <div>
              <span className=" text-gray-400 text-3xl 2xl:text-4xl absolute -top-5 2xl:-top-[22px] -left-20 2xl:-left-24">
                &#129170;
              </span>
            </div>{" "}
            <div className="absolute -top-2 2xl:-top-2.5 text-slate-400 left-0 w-4 h-4 2xl:w-5 2xl:h-5 bg-green-500 rounded-full flex justify-center items-center">
              {(value[12]?.order === 13 &&
                value[12]?.status === "Delivered to Customer") != true && (
                  <div className=" w-4 h-4 2xl:w-5 2xl:h-5 bg-slate-400 rounded-full "></div>
                )}
            </div>
            <div
              className={`${(value[12]?.order === 13 &&
                value[12]?.status === "Delivered to Customer") === true
                ? " text-black"
                : " text-slate-500"
                } absolute -left-11 top-3 w-[170px] 2xl:w-[200px]`}
            >
              <p className=" text-[10px] 2xl:text-xs absolute -left-0.5 2xl:-left-2 ">
                Delivered to Customer
              </p>
              <p className="text-[10px]  2xl:text-xs absolute left-6 2xl:left-6 top-4">
                {" "}
                {value[12]?.order === 13 &&
                  value[12]?.status === "Delivered to Customer" && (
                    <NuDate value={value[12]?.date} format="DD-MMM-YYYY" />
                  )}
              </p>
              {value[12]?.order === 13 &&
                value[12]?.status === "Delivered to Customer" && (
                  <p className=" text-[10px]  2xl:text-xs absolute left-10 2xl:left-11 top-8">
                    {DateBetween(value[0]?.date, value[12]?.date)}{" "}
                    {DateBetween(value[0]?.date, value[12]?.date) > 1
                      ? "Days"
                      : "Day"}
                  </p>
                )}
            </div>
          </div>
        </div>
        <div className="flex justify-end gap-2">
          <button
            className={`m-3 px-4 py-[6px] cursor-pointer text-xs 2xl:text-sm  text-textColor-main bg-[#E6F2F2] hover:bg-gray-300
      rounded-md flex items-center`}
            style={{ border: "none" }}
            onClick={closedate}
            type="button"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export const OrderFlow2 = ({ yprno, value }) => {
  if (!Array.isArray(value) || value.length === 0) {
    return (
      <div className="text-xs text-gray-500">No order flow data available</div>
    );
  }
  const stepsByOrder = Object.fromEntries(
    value?.map((step) => [step.order, step]) || [],
  );
  // console.log("stepsByOrder", stepsByOrder);

  const isStepActiveFast = (order, statuses = []) =>
    statuses.includes(stepsByOrder?.[order]?.status);

  const rawActive1 = isStepActiveFast(1, ["PR Created"]);
  const rawActive2 = isStepActiveFast(2, ["RFQ Floated"]);
  const rawActive3 = isStepActiveFast(3, ["Supplier Price Received"]);
  const rawActive4 = isStepActiveFast(4, ["Customer Quote Approved"]);
  const rawActive5 = isStepActiveFast(5, ["Quote Submitted to Customer"]);
  const rawActive6 = isStepActiveFast(6, [
    "PO Received from customer",
    "Lost the Order",
  ]);
  const rawActive7 = isStepActiveFast(7, ["Sales Order Released"]);

  const isActive7 = rawActive7;
  const isActive6 = rawActive6 || isActive7;
  const isActive5 = rawActive5 || isActive6;
  const isActive4 = rawActive4 || isActive5;
  const isActive3 = rawActive3 || isActive4;
  const isActive2 = rawActive2 || isActive3;
  const isActive1 = rawActive1 || isActive2;
  // const isActive8 = isStepActiveFast(8, ["PO to Supplier Approved"]);
  // const isActive9 = isStepActiveFast(9, ["PO placed with Supplier"]);
  // const isActive10 = isStepActiveFast(10, ["Order Shipped"]);
  // const isActive11 = isStepActiveFast(11, ["Order Under Customers clearance"]);
  // const isActive12 = isStepActiveFast(12, ["Order Received at Warehouse"]);
  // const isActive13 = isStepActiveFast(13, ["Delivered to Customer"]);

  // const isActive1 = isStepActive(value?.[0], 1, ["PR Created"]);
  // const isActive2 = isStepActive(value?.[1], 2, ["RFQ Floated"]);
  // const isActive3 = isStepActive(value?.[2], 3, ["Supplier Price Received"]);
  // const isActive4 = isStepActive(value?.[3], 4, ["Customer Quote Approved"]);
  // const isActive5 = isStepActive(value?.[4], 5, [
  //   "Quote Submitted to Customer",
  // ]);
  // const isActive6 = isStepActive(value?.[5], 6, [
  //   "PO Received from customer",
  //   "Lost the Order",
  // ]);
  // const isActive7 = isStepActive(value?.[6], 7, ["Sales Order Released"]);
  // const isActive8 = isStepActive(value?.[7], 8, ["PO to Supplier Approved"]);
  // const isActive9 = isStepActive(value?.[8], 9, ["PO placed with Supplier"]);
  // const isActive10 = isStepActive(value?.[9], 10, ["Order Shipped"]);
  // const isActive11 = isStepActive(value?.[10], 11, [
  //   "Order Under Customers clearance",
  // ]);
  // const isActive12 = isStepActive(value?.[11], 12, [
  //   "Order Received at Warehouse",
  // ]);stepsByOrder
  // const isActive13 = isStepActive(value?.[12], 13, ["Delivered to Customer"]);

  return (
    <div className="w-full overflow-x-auto whitespace-nowrap ">
      <div className=" w-full grid grid-cols-7 pt-4 gap-0">
        <div className=" border-x-0 h-12 relative">
          {/* 1 */}
          <div>
            <span className=" text-gray-400 text-3xl z-20  absolute -top-5  left-[60%] ">
              &#129170;
            </span>
          </div>
          <div className=" absolute top-0  left-5 right-0">
            <div className="h-[1px] w-full bg-gray-400"></div>
          </div>

          <div className="absolute -top-1 left-5">
            <StatusDot active={isActive1} />
          </div>
          <TimelineLabel3
            active={isActive1}
            title="YPR Created"
            date={stepsByOrder?.[1]?.date}
            position="left-0 top-3"
          />
        </div>
        <div className=" border-t-[1px] border-gray-400 border-x-0 h-12 relative ">
          {/* 2 */}
          <div>
            <span className=" text-gray-400 text-3xl  absolute -top-5  right-1/2 ">
              &#129170;
            </span>
          </div>
          <div className="absolute -top-1 left-0">
            <StatusDot active={isActive2} />
          </div>
          <TimelineLabel3
            position="-left-10 top-3"
            active={isActive2}
            title="RFQ Floated"
            date={stepsByOrder?.[2]?.date}
            fdate={stepsByOrder?.[1]?.date}
          />
        </div>
        <div className=" border-t-[1px] border-gray-400 border-x-0 h-12 relative">
          {/* 3 */}
          <div>
            <span className=" text-gray-400 text-3xl  absolute -top-5  right-1/2 ">
              &#129170;
            </span>
          </div>
          <div className="absolute -top-1 left-0">
            <StatusDot active={isActive3} />
          </div>
          <TimelineLabel3
            position="-left-12 top-3"
            active={isActive3}
            title="Supplier Price Received"
            date={stepsByOrder?.[3]?.date}
            fdate={stepsByOrder?.[1]?.date}
          />
        </div>
        <div className=" border-t-[1px] border-gray-400 border-x-0 h-12 relative">
          {/* 4 */}
          <div>
            <span className=" text-gray-400 text-3xl  absolute -top-5  right-1/2 ">
              &#129170;
            </span>
          </div>
          <div className="absolute -top-1 left-0">
            <StatusDot active={isActive4} />
          </div>
          <TimelineLabel3
            position="-left-14 top-3"
            active={isActive4}
            title="Customer Quote Approved"
            date={stepsByOrder?.[4]?.date}
            fdate={stepsByOrder?.[1]?.date}
          />
        </div>
        <div className=" border-t-[1px] border-gray-400 border-x-0 h-12 relative">
          {/* 5 */}
          <div>
            <span className=" text-gray-400 text-3xl  absolute -top-5  right-1/2 ">
              &#129170;
            </span>
          </div>
          <div className="absolute -top-1 left-0">
            <StatusDot active={isActive5} />
          </div>
          <TimelineLabel3
            position="-left-14 top-3"
            active={isActive5}
            title="Quote Submitted to Customer"
            date={stepsByOrder?.[5]?.date}
            fdate={stepsByOrder?.[1]?.date}
          />
        </div>
        <div className="border-t-[1px] border-gray-400 border-x-0 h-12 relative">
          {/* 6 */}
          <div>
            <span className=" text-gray-400 text-3xl  absolute -top-5  right-1/2 ">
              &#129170;
            </span>
          </div>
          <div className="absolute -top-1 left-0">
            <StatusDot active={isActive6} />
          </div>
          <TimelineLabel3
            position="-left-16 top-3"
            active={isActive6}
            title={
              stepsByOrder[6]?.status === "PO Received from customer"
                ? "PO Received from customer"
                : stepsByOrder[6]?.status === "Lost the Order"
                  ? "Lost the Order"
                  : "PO Received from customer / Lost the Order"
            }
            // title="PO Received from customer"
            date={stepsByOrder?.[6]?.date}
            fdate={stepsByOrder?.[1]?.date}
          />
        </div>
        <div
          // border-[1.5px] border-l-0
          className="relative 
        
         h-12 rounded-e-full"
        >
          {/* 7 */}
          {/* <div>
            <span className=" text-gray-400 text-3xl  absolute -top-5  right-1/2 ">
              &#129170;
            </span>
          </div> */}
          <div className="absolute -top-1 left-0">
            <StatusDot active={isActive7} />
          </div>
          <TimelineLabel3
            position="-left-10 top-3"
            active={isActive7}
            title="Sales Order Released"
            date={stepsByOrder?.[7]?.date}
            fdate={stepsByOrder?.[1]?.date}
          />
        </div>

        {/* <div>9</div>  <div>10</div> 
        <div>11 </div>

        {/* <div className="relative">
          //  12 
          <div>
            <span className=" text-gray-400 text-3xl  absolute -top-5  right-1/2 ">
              &#129168;
            </span>
          </div>
          <div className="absolute -top-1 left-0">
            <StatusDot active={isActive13} />
          </div>
          <TimelineLabel3
            position="-left-14 top-3"
            active={isActive13}
            title="Delivered to Customer"
            date={stepsByOrder?.[13]?.date}
            fdate={stepsByOrder?.[1]?.date}
          />
        </div>
        <div className="relative">
          //  13 
          <div>
            <span className=" text-gray-400 text-3xl  absolute -top-5  right-1/2 ">
              &#129168;
            </span>
          </div>
          <div className="absolute -top-1 left-0">
            <StatusDot active={isActive12} />
          </div>
          <TimelineLabel3
            position="-left-14 top-3"
            active={isActive12}
            title="Order Received at Warehouse"
            date={stepsByOrder?.[12]?.date}
            fdate={stepsByOrder?.[1]?.date}
          />
        </div>
        <div className="relative">
          // 14
          <div>
            <span className=" text-gray-400 text-3xl  absolute -top-5  right-1/2 ">
              &#129168;
            </span>
          </div>
          <div className="absolute -top-1 left-0">
            <StatusDot active={isActive11} />
          </div>
          <TimelineLabel3
            position="-left-12 top-3"
            active={isActive11}
            title="Order Under Customers"
            date={stepsByOrder?.[11]?.date}
            fdate={stepsByOrder[1].date}
          />
        </div>
        <div className="  relative">
          //  15 
          <div>
            <span className=" text-gray-400 text-3xl  absolute -top-5  right-1/2 ">
              &#129168;
            </span>
          </div>
          <div className="absolute -top-1 left-0">
            <StatusDot active={isActive10} />
          </div>
          <TimelineLabel3
            position="-left-5 top-3"
            active={isActive10}
            title="Order Shipped"
            date={stepsByOrder?.[10]?.date}
            fdate={stepsByOrder[1].date}
          />
        </div>
        <div className="  relative">
          //  16 
          <div>
            <span className=" text-gray-400 text-3xl  absolute -top-5  right-1/2 ">
              &#129168;
            </span>
          </div>
          <div className="absolute -top-1 left-0">
            <StatusDot active={isActive9} />
          </div>
          <TimelineLabel3
            position="-left-11 top-3"
            active={isActive9}
            title="PO placed with Supplier"
            date={stepsByOrder?.[9]?.date}
            fdate={stepsByOrder[1].date}
          />
        </div>
        <div className="relative ">
          //  8 
          <div>
            <span className=" text-gray-400 text-3xl  absolute -top-5  right-1/2 ">
              &#129168;
            </span>
          </div>
          <div className="absolute -top-1 left-0">
            <StatusDot active={isActive8} />
          </div>
          <TimelineLabel3
            position="-left-11 top-3"
            active={isActive8}
            title="Po to Supplier Approved"
            date={stepsByOrder?.[8]?.date}
            fdate={stepsByOrder[1].date}
          />
        </div> */}
      </div>
    </div>
  );
};

export const OrderFlowPO = ({ value }) => {
  if (!Array.isArray(value) || value.length === 0) {
    return (
      <div className="text-xs text-gray-500">No order flow data available</div>
    );
  }
  const stepsByOrder = Object.fromEntries(
    value?.map((step) => [step.order, step]) || [],
  );

  const isStepActiveFast = (order, statuses = []) =>
    statuses.includes(stepsByOrder?.[order]?.status);

  const rawActive6 = isStepActiveFast(6, [
    "PO Received from customer",
    "Lost the Order",
  ]);
  const rawActive7 = isStepActiveFast(7, ["Sales Order Released"]);
  const rawActive8 = isStepActiveFast(8, ["PO to Supplier Approved"]);
  const rawActive9 = isStepActiveFast(9, ["PO placed with Supplier"]);
  const rawActive10 = isStepActiveFast(10, ["Order Shipped"]);
  const rawActive11 = isStepActiveFast(11, ["Order Under Customers clearance"]);
  const rawActive12 = isStepActiveFast(12, ["Order Received at Warehouse"]);
  const rawActive13 = isStepActiveFast(13, [
    "Delivered to Customer",
    "Delivered to Customer",
  ]);

  const isActive13 = rawActive13;
  const isActive12 = rawActive12 || isActive13;
  const isActive11 = rawActive11 || isActive12;
  const isActive10 = rawActive10 || isActive11;
  const isActive9 = rawActive9 || isActive10;
  const isActive8 = rawActive8 || isActive9;
  const isActive7 = rawActive7 || isActive8;
  const isActive6 = rawActive6 || isActive7;

  // const isActive8 = isStepActive(value?.[7], 8, ["PO to Supplier Approved"]);
  // const isActive9 = isStepActive(value?.[8], 9, ["PO placed with Supplier"]);
  // const isActive10 = isStepActive(value?.[9], 10, ["Order Shipped"]);
  // const isActive11 = isStepActive(value?.[10], 11, [
  //   "Order Under Customers clearance",
  // ]);
  // const isActive12 = isStepActive(value?.[11], 12, [
  //   "Order Received at Warehouse",
  // ]);
  // const isActive13 = isStepActive(value?.[12], 13, ["Delivered to Customer"]);

  return (
    <div className="w-full overflow-x-auto whitespace-nowrap ">
      <div className=" w-full grid grid-cols-8 pt-4 pb-8 mb-2 gap-0">
        <div className=" relative">
          {/* 1 */}
          <div>
            <span className=" text-gray-400 text-3xl z-20  absolute -top-5  left-[70%] ">
              &#129170;
            </span>
          </div>
          <div className=" absolute top-0 left-7 right-0">
            <div className="h-[1px] w-full bg-gray-400"></div>
          </div>
          <div className="absolute -top-1 left-7">
            <StatusDot active={isActive6} />
          </div>
          <TimelineLabel3
            position="left-0 top-3"
            active={isActive6}
            title={
              stepsByOrder[6]?.status === "PO Received from customer"
                ? "PO Received from customer"
                : stepsByOrder[6]?.status === "Lost the Order"
                  ? "Lost the Order"
                  : "PO Received from customer / Lost the Order"
            }
            // title="PO Received from customer"
            date={stepsByOrder?.[6]?.date}
            fdate={stepsByOrder?.[1]?.date}
          />
        </div>
        <div className="relative border-t-[1px] border-gray-400">
          {/* 2 */}
          <div>
            <span className=" text-gray-400 text-3xl -red-500 absolute -top-5  left-[60%] ">
              &#129170;
            </span>
          </div>
          <div className="absolute -top-1 left-7">
            <StatusDot active={isActive7} />
          </div>
          <TimelineLabel3
            position="-left-0 top-3"
            active={isActive7}
            title="Sales Order Released"
            date={stepsByOrder?.[7]?.date}
            fdate={stepsByOrder?.[1]?.date}
          />
        </div>
        <div className="relative border-t-[1px] border-gray-400">
          {/* 3 */}
          <div>
            <span className=" text-gray-400 text-3xl  absolute -top-5  left-[60%] ">
              &#129170;
            </span>
          </div>
          <div className="absolute -top-1 left-2">
            <StatusDot active={isActive8} />
          </div>
          <TimelineLabel3
            position="-left-7 top-3"
            active={isActive8}
            title="Po to Supplier Approved"
            date={stepsByOrder?.[8]?.date}
            fdate={stepsByOrder?.[1]?.date}
          />
        </div>
        <div className="border-t-[1px] border-gray-400  relative ">
          {/* 4 */}
          <div>
            <span className=" text-gray-400 text-3xl  absolute -top-5  left-[60%] ">
              &#129170;
            </span>
          </div>
          <div className="absolute -top-1 left-3">
            <StatusDot active={isActive9} />
          </div>
          <TimelineLabel3
            position="-left-7 top-3"
            active={isActive9}
            title="PO placed with Supplier"
            date={stepsByOrder?.[9]?.date}
            fdate={stepsByOrder?.[1]?.date}
          />
        </div>
        <div className="border-t-[1px] border-gray-400   relative">
          {/* 5 */}
          <div>
            <span className=" text-gray-400 text-3xl  absolute -top-5  right-1/2 ">
              &#129170;
            </span>
          </div>
          <div className="absolute -top-1 left-0">
            <StatusDot active={isActive10} />
          </div>
          <TimelineLabel3
            position="-left-5 top-3"
            active={isActive10}
            title="Order Shipped"
            date={stepsByOrder?.[10]?.date}
            fdate={stepsByOrder?.[1]?.date}
          />
        </div>
        <div className="border-t-[1px] border-gray-400  relative">
          {/* 6 */}
          <div>
            <span className=" text-gray-400 text-3xl  absolute -top-5  right-1/2 ">
              &#129170;
            </span>
          </div>
          <div className="absolute -top-1 left-0">
            <StatusDot active={isActive11} />
          </div>
          <TimelineLabel3
            position="-left-10 top-3"
            active={isActive11}
            title="Order Under Customers"
            date={stepsByOrder?.[11]?.date}
            fdate={stepsByOrder?.[1]?.date}
          />
        </div>
        <div className="border-t-[1px] border-gray-400  relative">
          {/* 7 */}
          <div>
            <span className=" text-gray-400 text-3xl  absolute -top-5  right-1/2 ">
              &#129170;
            </span>
          </div>
          <div className="absolute -top-1 left-0">
            <StatusDot active={isActive12} />
          </div>
          <TimelineLabel3
            position="-left-10 top-3"
            active={isActive12}
            title="Order Received at Warehouse"
            date={stepsByOrder?.[12]?.date}
            fdate={stepsByOrder?.[1]?.date}
          />
        </div>
        <div className=" relative">
          {/* 8 */}
          {/* <div>
            <span className=" text-gray-400 text-3xl  absolute -top-5  right-1/2 ">
              &#129168;
            </span>
          </div> */}
          <div className="absolute -top-1 left-0">
            <StatusDot active={isActive13} />
          </div>
          <TimelineLabel3
            position="-left-10 top-3"
            active={isActive13}
            title="Delivered to Customer"
            date={stepsByOrder?.[13]?.date}
            fdate={stepsByOrder?.[1]?.date}
          />
        </div>
        {/* <div>7</div>
        <div>8</div> */}
      </div>
    </div>
  );
};

// const TimelineLabel = ({ active, title, date }) => {
//   return (
//     <div
//       className={`
//         absolute left-0 top-3
//         max-w-[170px] 2xl:max-w-[200px]
//         text-[8px]
//         whitespace-nowrap
//         overflow-hidden
//         text-ellipsis
//         ${active ? "text-black" : "text-slate-500"}
//       `}
//     >
//       <p className="font-normal truncate">{title}</p>

//       {active && date && (
//         <p className="truncate">
//           <NuDate value={date} format="DD-MMM-YYYY" />
//         </p>
//       )}
//     </div>
//   );
// };

export const OrderFlowPR = ({ value }) => {
  if (!Array.isArray(value) || value.length === 0) {
    return (
      <div className="text-xs text-gray-500">No order flow data available</div>
    );
  }

  const stepsByOrder = Object.fromEntries(
    value.map((step) => [step.order, step]) || [],
  );

  const isStepActiveFast = (order, statuses = []) =>
    statuses.includes(stepsByOrder?.[order]?.status);

  const rawActive1 = isStepActiveFast(1, ["PR Created"]);
  const rawActive2 = isStepActiveFast(2, ["RFQ Floated"]);
  const rawActive3 = isStepActiveFast(3, ["Supplier Price Received"]);
  const rawActive4 = isStepActiveFast(4, ["Customer Quote Approved"]);
  const rawActive5 = isStepActiveFast(5, ["Quote Submitted to Customer"]);
  const rawActive6 = isStepActiveFast(6, [
    "PO Received from customer",
    "Lost the Order",
  ]);
  const rawActive7 = isStepActiveFast(7, ["Sales Order Released"]);

  const isActive7 = rawActive7;
  const isActive6 = rawActive6 || isActive7;
  const isActive5 = rawActive5 || isActive6;
  const isActive4 = rawActive4 || isActive5;
  const isActive3 = rawActive3 || isActive4;
  const isActive2 = rawActive2 || isActive3;
  const isActive1 = rawActive1 || isActive2;

  const stepConfigs = [
    {
      order: 1,
      active: isActive1,
      title: "YPR Created",
      date: stepsByOrder?.[1]?.date,
      showArrow: true,
    },
    {
      order: 2,
      active: isActive2,
      title: "RFQ Floated",
      date: stepsByOrder?.[2]?.date,
      showArrow: true,
    },
    {
      order: 3,
      active: isActive3,
      title: "Supplier Price Received",
      date: stepsByOrder?.[3]?.date,
      showArrow: true,
    },
    {
      order: 4,
      active: isActive4,
      title: "Customer Quote Approved",
      date: stepsByOrder?.[4]?.date,
      showArrow: true,
    },
    {
      order: 5,
      active: isActive5,
      title: "Quote Submitted to Customer",
      date: stepsByOrder?.[5]?.date,
      showArrow: true,
    },
    {
      order: 6,
      active: isActive6,
      title:
        stepsByOrder[6]?.status === "PO Received from customer"
          ? "PO Received from customer"
          : stepsByOrder[6]?.status === "Lost the Order"
            ? "Lost the Order"
            : "PO Received from customer / Lost the Order",
      date: stepsByOrder?.[6]?.date,
      showArrow: true,
    },
    {
      order: 7,
      active: isActive7,
      title: "Sales Order Released",
      date: stepsByOrder?.[7]?.date,
      showArrow: false,
    },
  ];

  return (
    <div className="w-full overflow-x-auto">
      <div className="w-full grid grid-cols-7 py-4">
        {stepConfigs.map((step, index) => (
          <div
            key={step.order}
            className={`relative ${index === 0 ? "pl-0" : "pl-4"} ${index === stepConfigs.length - 1 ? "pr-4" : "pr-0"
              }`}
          >
            {/* Horizontal line between dots */}
            {index < stepConfigs.length - 1 && (
              <div className="absolute top-[3px] left-8 right-0 h-[2px] bg-gray-400" />
            )}

            {/* Arrow indicator */}
            {step.showArrow && (
              <span className="absolute top-[4px] -translate-y-1/2 left-1/2 transform -translate-x-1/2 text-gray-400 text-3xl">
                &#129170;
              </span>
            )}

            {/* Status dot */}
            <div className="absolute top-0 left-0">
              <StatusDot active={step.active} />
            </div>

            {/* Title and date - positioned below the dot */}
            <TimelineLabel3
              active={step.active}
              title={step.title}
              date={step.date}
              position="left-0 top-8 text-center"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export const OrderFlowShipment = ({ value, createdAt }) => {
  if (!Array.isArray(value) || value.length === 0) {
    return (
      <div className="text-xs text-gray-500">No order flow data available</div>
    );
  }
  const stepsByOrder = Object.fromEntries(
    value?.map((step) => [step.order, step]) || [],
  );

  const isStepActiveFast = (order, statuses = []) =>
    statuses.includes(stepsByOrder?.[order]?.status);

  const rawActive9 = isStepActiveFast(9, ["PO placed with Supplier"]);
  const rawActive10 = isStepActiveFast(10, ["Order Shipped"]);
  const rawActive11 = isStepActiveFast(11, ["Order Under Customers clearance"]);
  const rawActive12 = isStepActiveFast(12, ["Order Received at Warehouse"]);
  const rawActive13 = isStepActiveFast(13, [
    "Delivered to Customer",
    "Delivered to Customer",
  ]);

  const isActive13 = rawActive13;
  const isActive12 = rawActive12 || isActive13;
  const isActive11 = rawActive11 || isActive12;
  const isActive10 = rawActive10 || isActive11;
  const isActive9 = true;

  const steps = [
    { order: 9, title: "PO placed", active: isActive9, date: stepsByOrder?.[9]?.date || createdAt },
    { order: 10, title: "Order Shipped", active: isActive10 },
    { order: 11, title: "Order Under Clearance", active: isActive11 },
    { order: 12, title: "Received at Warehouse", active: isActive12 },
    { order: 13, title: "Delivered to Customer", active: isActive13 },
  ];

  return (
    <div className="w-full overflow-x-auto whitespace-nowrap">
      <div className="w-full ps-8 px-16">
        <div className="w-full flex justify-between items-start pt-2 pb-2 mb-2 relative min-h-[48px]">
          {/* Connector line spanning full width of the inner container */}
          <div className="absolute top-[12px] left-0 right-0 h-[1px] z-0 bg-slate-400" />

          {/* Arrow indicators */}
          {steps.map((step, index) =>
            index < steps.length - 1 && (
              <span
                key={`arrow-${step.order}`}
                className="absolute text-gray-400 text-3xl z-20 -translate-x-1/2 -translate-y-[57%] pointer-events-none"
                style={{
                  left: `${((index + 0.5) / (steps.length - 1)) * 100}%`,
                  top: "14px"
                }}
              >
                &#129170;
              </span>
            )
          )}

          {steps.map((step, index) => (
            <div
              key={step.order}
              className="w-2 h-2 relative z-10 flex items-center justify-center"
            >
              {/* Status dot */}
              <StatusDot active={step.active} />

              {/* Title and date */}
              <TimelineLabel3
                position="left-1/2 -translate-x-1/2 top-4 w-[130px] 2xl:w-[150px]"
                active={step.active}
                title={step.title}
                date={step.date || stepsByOrder?.[step.order]?.date}
                fdate={stepsByOrder?.[1]?.date}
                align="center"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
// You'll need to update TimelineLabel3 component to support center alignment
// Here's a suggested update for TimelineLabel3:

const TimelineLabel = ({ active, title, date, position = "" }) => {
  return (
    <div className={`absolute ${position} w-full flex flex-col items-center`}>
      <div
        className={`text-xs font-medium whitespace-normal text-center ${active ? "text-blue-600" : "text-gray-500"
          }`}
        style={{ maxWidth: "120px" }}
      >
        {title}
      </div>
      {date && (
        <div className="text-xs text-gray-400 mt-1">
          {new Date(date).toLocaleDateString()}
        </div>
      )}
    </div>
  );
};

const TimelineLabel3 = ({ active, title, date, fdate, position, status, align = "center" }) => {
  const duration = active && fdate && date ? DateBetween(fdate, date) : null;

  const alignClass = align === "left" ? "text-left" : align === "right" ? "text-right" : "text-center";
  const justifyClass = align === "left" ? "justify-start" : align === "right" ? "justify-end" : "justify-center";

  return (
    <div
      className={`
        absolute ${position} z-0
        max-w-[160px] 2xl:max-w-[190px]
        text-[8px]
        overflow-hidden
        whitespace-normal
        ${active ? "text-black" : "text-slate-500"}
      `}
    >
      {/* TITLE (2-line clamp) */}
      <p className={`font-normal leading-tight line-clamp-2 ${alignClass}`}>
        {title === "PO Received from customer / Lost the Order" ? (
          <>
            <div>PO Received from customer</div>
            <div>/ Lost the Order</div>
          </>
        ) : (
          title
        )}
      </p>

      {/* DATE */}
      {active && date && (
        <div className={`align-middle truncate flex items-center gap-1 ${justifyClass}`}>
          <NuDate value={date} format="DD-MMM-YYYY" /> {/* DURATION */}
          {typeof duration === "number" && (
            <span className="truncate">
              ({duration} {duration > 1 ? "days" : "day"})
            </span>
          )}
        </div>
      )}
    </div>
  );
};

// StatusDot component remains the same
const StatusDot = ({ active = false }) => {
  return (
    <div
      className={`w-2 h-2 rounded-full border-2 ${active
        ? "bg-green-500 border-green-500"
        : "bg-slate-400 border-slate-400"
        }`}
    />
  );
};

// const StatusDot = ({ active = false }) => {
//   return (
//     <div
//       className={`w-2 h-2 rounded-full ${
//         active ? "bg--500" : "bg--400"
//       }`}
//     />
//   );
// };